import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'reflexbox';
import { Text } from 'rebass';

import config from 'frontend/config';

const ToggleBox = ({
  selected,
  warning,
  text,
  textSize,
  children,
  ...props
}) => {
  let borderColor = '#555';
  let backgroundColor = 'transparent';
  let textColor = null;
  if (selected) {
    backgroundColor = '#222';
    textColor = config.colors.orange;
    if (warning) {
      borderColor = config.colors.red;
    } else {
      borderColor = config.colors.orange;
    }
  }
  let content;
  if (children) {
    content = children;
  } else {
    content = (
      <Text
        bold={selected}
        color={textColor}
        size={textSize}
      >
        {text}
      </Text>
    );
  }
  return (
    <Box
      {...props}
      style={{
        cursor: 'pointer',
        border: `1px solid ${borderColor}`,
        backgroundColor,
        padding: 6,
        position: 'relative',
        userSelect: 'none',
      }}
    >
      {content}
    </Box>
  );
};

ToggleBox.propTypes = {
  selected: PropTypes.bool,
  warning: PropTypes.bool,
  text: PropTypes.string,
  textSize: PropTypes.number,
  children: PropTypes.node,
};

ToggleBox.defaultProps = {
  selected: false,
  warning: false,
  text: null,
  textSize: 16,
  children: null,
};

export default ToggleBox;
